import React, { useEffect, useState } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";

import { Input } from "../../../component/form/input";
import { LoginData } from "../../../redux/featuer/user/userSlice";
import toast from "react-hot-toast";

export default function MarkerLess({
    name,
    type
}) {
    const dispatch = useDispatch();
    const { login, token } = useSelector((item) => item.user)
    const [stepPage, setStepPage] = useState(1)

    const [limitedView, setLimitedView] = useState(0)
    const [glbDataContent, setGlbDataContent] = useState(null)
    const [glbDataError, setGlbDataError] = useState("")
    const [usdzDataContent, setUsdzDataContent] = useState(null)
    const [usdzDataError, setUsdzDataError] = useState("")
    const [preview, setPreview] = useState(null)
    const [progressBar, setProgressBar] = useState(0);
    const [progressDone, setProgressDone] = useState([]) // MARKER, VIDEO

    const axiosInstance = axios.create({
        baseURL: `${process.env.REACT_APP_SERVER}`,
        timeout: 3000000 // only wait
    });


    useEffect(() => {
        if (glbDataContent != null && usdzDataContent != null) {
            setPreview(glbDataContent)
        } else {
            setPreview(null)
        }
    }, [glbDataContent, usdzDataContent])

    const handleButtonDisableContinue = () => {
        if (glbDataContent != null && usdzDataContent != null) {
            return false
        }
        return true;
    }

    const checkSetContentData = (e, type) => {
        if (e.target.files[0].size > 50000001) {
            if (type == "GLB") {
                setGlbDataError("حجم فایل شما بیش از حد مجاز می باشد")
            }
            if (type == "USDZ") {
                setUsdzDataError("حجم فایل شما بیش از حد مجاز می باشد")
            }
            return;
        }
        const name = e.target.files[0].name
        const array = name.split(".");
        const format = array[array.length - 1];

        if (type == "GLB") {
            if (format.toLowerCase() != "glb") {
                setGlbDataError("فرمت صحیح نمی باشد")
            } else {
                setGlbDataError(null)
                setGlbDataContent(e.target.files[0])
            }
        }

        if (type == "USDZ") {
            if (format.toLowerCase() != "usdz") {
                setUsdzDataError("فرمت صحیح نمی باشد")
            } else {
                setUsdzDataError(null)
                setUsdzDataContent(e.target.files[0])
            }
        }

    }


    const startMakeAR = async (e) => {
        e.preventDefault();
        setStepPage(2)
        setProgressDone([{
            title: "احراز هویت",
            status: "DONE" // DONE, WAIT
        },
        {
            title: "آنالیز داده ها",
            status: "DONE" // DONE, WAIT
        },
        {
            title: "ارسال داده ها به سرور",
            status: "WAIT" // DONE, WAIT
        }])
        submitForm()
    }

    const submitForm = async () => {

        setProgressBar(0)
        const formData = new FormData();

        formData.append("glb", glbDataContent);
        formData.append("usdz", usdzDataContent);
        formData.append("name", name);
        formData.append("types", type);
        if (limitedView !== null) {
            formData.append("limited_view", limitedView);
        }

        await axiosInstance.post("/api/nft/", formData, {
            headers: {
                // 'Content-Type': 'application/json',
                Authorization: "ArNew " + token,
            },
            onUploadProgress: data => {
                var percentComplete = Math.ceil((100 * data.loaded) / data.total);
                setProgressBar(percentComplete)
                document.getElementById("progressBar").style.width = percentComplete.toString() + "%";
            }
        })
            .then(
                function (response) {
                    if (response.data.status === "success") {
                        editStatusProcess("ارسال داده ها به سرور", "DONE")
                        if (typeof window !== 'undefined') {
                            dispatch(LoginData(response.data.data.user));
                            window.location.href = `${process.env.REACT_APP_CLIENT}/projects/edit/${response.data.data._id}`;
                        }
                    } else {
                        toast.error(response?.data?.msg);
                    }
                }
            ).catch(function ({ response }) {
                if (response.status !== 200) {
                    toast.error(response?.data?.msg)
                }
            });
    }

    const editStatusProcess = (title, status) => {
        setProgressDone(prevState => {
            return prevState.map((item) => {
                // Check for the item with the specified id and update it
                return item.title === title ? { title: title, status: status } : item
            })
        })
    }

    return (
        stepPage == 1 ?
            <>
                <h1 className="font-extrabold text-2xl text-start text-gray-700 mt-5">شما درحال ایجاد واقعیت افزوده براساس بدون نشانگر با نام <span className="text-gray-900">«{name}»</span> هستید</h1>
                <h4 className="font-normal text-lg text-start text-gray-600 mt-3">
                    میخوایی حرفه ای عمل کنی؟ به چندتا نکته توجه کن!
                    <p className="mt-3 mx-2 text-base">1- بهتر است از مدل کم حجم استفاده کنید تا مخاطب دسترسی آسانتر داشته باشد.</p>
                    <p className="mt-2 mx-2 text-base">2- دقت کنید مدل شما نمی تواند بیشتر از ۵۰ مگابایت باشد.</p>
                    <p className="mt-2 mx-2 text-base">3- برای تبدیل فرمت خود به فرمت های usdz, glb از سایت زیر استفاده کنید.</p>
                    <p className="mt-2 mx-4 text-base"><a href="https://products.aspose.app/3d/conversion" target="_blank" className="text-blue-700">ورود به سایت تبدیل فرمت سه بعدی</a></p>
                </h4>

                <h1 className="col-span-2 font-extrabold text-xl text-start text-black my-auto mt-8 mx-5">بارگذاری مدل GLB (برای دستگاه های اندروید)</h1>
                <div className="flex items-center justify-center w-full my-3">
                    <label htmlFor="dropzone-file-glb" className={`relative flex flex-col items-center justify-center w-full h-64 border-2 ${glbDataError ? "border-red-500" : "border-gray-300"} border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-bray-800 hover:bg-gray-100`}>
                        {glbDataContent != null ?
                            (
                                <>
                                    <span>{glbDataContent.name}</span>
                                    <div
                                        onClick={() => { setGlbDataContent(null); setGlbDataError(null) }}
                                        className="absolute right-0 top-0 m-2 p-2 shadow-lg  border border-1 border-gray-300 rounded-lg bg-white hover:border-red-600 hover:bg-red-500 hover:shadow-slate-400 cursor-pointer">
                                        <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512"><path d="M170.5 51.6L151.5 80h145l-19-28.4c-1.5-2.2-4-3.6-6.7-3.6H177.1c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80H368h48 8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V432c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V128H24c-13.3 0-24-10.7-24-24S10.7 80 24 80h8H80 93.8l36.7-55.1C140.9 9.4 158.4 0 177.1 0h93.7c18.7 0 36.2 9.4 46.6 24.9zM80 128V432c0 17.7 14.3 32 32 32H336c17.7 0 32-14.3 32-32V128H80zm80 64V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16z" /></svg>
                                    </div>

                                </>
                            )
                            :
                            (
                                <>
                                    <div className="flex flex-col items-center justify-center pt-5 pb-6">
                                        <svg className="w-8 h-8 mb-4 text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 16">
                                            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2" />
                                        </svg>
                                        <p className="text-red-500 text-sm mb-2">{glbDataError}</p>
                                        <p className="mb-2 text-sm text-gray-500"><span className="font-semibold">برای بارگذاری کلیک کنید</span> یا فایل را اینجا رها کنید</p>
                                        <p className="text-xs text-gray-500">GLB (MAX. 50 MB)</p>
                                    </div>
                                    <input
                                        id="dropzone-file-glb"
                                        type="file"
                                        className="hidden"
                                        multiple={false}
                                        onChange={(e) => {
                                            if (e.target.files.length > 0) {
                                                checkSetContentData(e, "GLB")
                                            }
                                        }}
                                    />
                                </>
                            )
                        }

                    </label>
                </div>

                <h1 className="col-span-2 font-extrabold text-xl text-start text-black my-auto mt-8 mx-5">بارگذاری مدل USDZ (برای دستگاه های آی او اس)</h1>
                <div className="flex items-center justify-center w-full my-3">
                    <label htmlFor="dropzone-file-usdz" className={`relative flex flex-col items-center justify-center w-full h-64 border-2 ${usdzDataError ? "border-red-500" : "border-gray-300"} border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-bray-800 hover:bg-gray-100`}>
                        {usdzDataContent != null ?
                            (
                                <>
                                    <span>{usdzDataContent.name}</span>
                                    <div
                                        onClick={() => { setUsdzDataContent(); setUsdzDataError(null) }}
                                        className="absolute right-0 top-0 m-2 p-2 shadow-lg  border border-1 border-gray-300 rounded-lg bg-white hover:border-red-600 hover:bg-red-500 hover:shadow-slate-400 cursor-pointer">
                                        <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512"><path d="M170.5 51.6L151.5 80h145l-19-28.4c-1.5-2.2-4-3.6-6.7-3.6H177.1c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80H368h48 8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V432c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V128H24c-13.3 0-24-10.7-24-24S10.7 80 24 80h8H80 93.8l36.7-55.1C140.9 9.4 158.4 0 177.1 0h93.7c18.7 0 36.2 9.4 46.6 24.9zM80 128V432c0 17.7 14.3 32 32 32H336c17.7 0 32-14.3 32-32V128H80zm80 64V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16z" /></svg>
                                    </div>

                                </>
                            )
                            :
                            (
                                <>
                                    <div className="flex flex-col items-center justify-center pt-5 pb-6">
                                        <svg className="w-8 h-8 mb-4 text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 16">
                                            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2" />
                                        </svg>
                                        <p className="text-red-500 text-sm mb-2">{usdzDataError}</p>
                                        <p className="mb-2 text-sm text-gray-500"><span className="font-semibold">برای بارگذاری کلیک کنید</span> یا فایل را اینجا رها کنید</p>
                                        <p className="text-xs text-gray-500">USDZ (MAX. 50 MB)</p>
                                    </div>
                                    <input
                                        id="dropzone-file-usdz"
                                        type="file"
                                        className="hidden"
                                        multiple={false}
                                        onChange={(e) => {
                                            if (e.target.files.length > 0) {
                                                checkSetContentData(e, "USDZ")
                                            }
                                        }}
                                    />
                                </>
                            )
                        }

                    </label>
                </div>

                <h1 className="font-extrabold text-xl text-start text-black mt-8 mx-5">گزینه های اضافی</h1>
                <h4 className="font-normal text-lg text-start text-gray-600 mx-5 my-3">
                    این بخش اختیاری می باشد.
                </h4>
                <h4 className="font-normal text-lg text-start text-gray-600 mx-5 my-3">
                    در این بخش می توانید محدودیت بازدید تعریف کنید که بعد از اتمام محدودیت بازدید پروژه غیرفعال خواهد شد.
                </h4>
                <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 gap-2">
                    <div className="relative mt-2 ">
                        <Input
                            placeholder={"محدودیت بازدید (صفر به عنوان نامحدود می باشد)"}
                            type="number"
                            id={"limited_view"}
                            name={"limited_view"}
                            autoComplete={"off"}
                            requiredir={true}
                            defaultValue={limitedView}
                            onChange={(e) => {
                                if (e.target.value < 0) {
                                    e.target.value = 0
                                }
                                setLimitedView(e.target.value);
                            }}
                        />
                    </div>
                </div>

                {preview ?
                    (
                        <>
                            <h1 className="col-span-2 font-extrabold text-xl text-start text-black my-auto mt-8 mx-5">پیش نمایش مدل</h1>
                            <div className="my-3">
                                <label className={`relative flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-bray-800 hover:bg-gray-100`}>
                                    <model-viewer auto-rotate alt="Uploaded Model" src={URL.createObjectURL(preview)} shadow-intensity="1" camera-controls touch-action="pan-y"></model-viewer>
                                </label>
                            </div>
                        </>
                    ) : (
                        <>
                        </>
                    )
                }


                <div className="w-full flex justify-end">
                    < button
                        disabled={handleButtonDisableContinue()}
                        className={` ${handleButtonDisableContinue() ? "bg-gray-100 text-gray-700 font-normal" : "bg-emerald-500 hover:shadow-lg text-white active:bg-emerald-600 font-bold"} uppercase text-lg px-6 py-3 my-5 rounded shadow  outline-none focus:outline-none ease-linear transition-all duration-150`}
                        type="button"
                        onClick={startMakeAR}
                    >
                        ثبت و ایجاد
                    </button >
                </div>

            </>
            :
            <>
                <div className="m-auto w-1/2 lg:w-1/3 xl:w-1/3">
                    <img className="free-image w-full object-cover rounded-lg" src={process.env.REACT_APP_ADDRESS + "/panel/upload-process.gif"} />
                </div>

                <div className="mt-8" role="status">
                    <span className="p-2">درحال ایجاد واقعیت افزوده هستیم، این پردازش به حجم داده های شما بستگی دارد.</span>
                    <div className="my-4">
                        <div className="w-full mt-4 bg-gray-200 rounded-full dark:bg-gray-700">
                            <div id="progressBar" className="bg-green-600 text-xs font-medium text-blue-100 text-center p-0.5 leading-none rounded-full">{progressBar}%</div>
                        </div>
                    </div>
                </div>
                {progressDone.map((item, index) => {
                    return (
                        <div key={index} className="flex p-2">
                            {
                                item.status == "DONE" ?
                                    (
                                        <>
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="#00ac8b" height="1.2em" viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" /></svg>
                                            <div className="px-2 font-normal text-base text-black">{item.title}</div>
                                        </>
                                    ) : (
                                        <>
                                            <svg className="inline text-gray-200 animate-spin fill-blue-600" height="1.2em" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                                                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                                            </svg>
                                            <span className="px-2 font-normal text-base text-black">{item.title}</span>
                                        </>
                                    )
                            }
                        </div>
                    )
                })}
            </>
    );
}